import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalWrapper from '../../../components/modalWrapper';
import Loading from '../../../components/common/Loading';

function ModalExportClaimTasks({
  openModal,
  setOpenModal,
  onConfirmExport,
  onDownload,
  isLoading,
  downloadReady,
  errorMessage,
}) {
  const { t } = useTranslation();

  function handleClose() {
    setOpenModal(false);
  }

  return (
    <ModalWrapper
      headerTitle={t('exportClaimTasks')}
      openModal={openModal}
      setModalWrapper={handleClose}
    >
      {isLoading ? (
        <div className="d-flex flex-row justify-content-center align-items-center" style={{ minHeight: '120px' }}>
          <Loading noText fast scroll={false} color={'#FE4B4E'} />
        </div>
      ) : downloadReady ? (
        <>
          <div className="modal_container__body__text">{t('exportClaimTasksReadyText')}</div>
          <div className="d-flex flex-row justify-content-center align-items-center" style={{ gap: '8px', marginTop: '14px' }}>
            <button className="button_red_small" onClick={onDownload}>
              {t('downloadXlsx')}
            </button>
            <button className="button_red_small" onClick={handleClose}>
              {t('close')}
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="modal_container__body__text">
            {errorMessage || t('exportClaimTasksConfirmText')}
          </div>
          <div className="d-flex flex-row justify-content-center align-items-center" style={{ gap: '8px', marginTop: '14px' }}>
            {!errorMessage && (
              <button className="button_red_small" onClick={onConfirmExport}>
                {t('confirm')}
              </button>
            )}
            <button className="button_red_small" onClick={handleClose}>
              {t('close')}
            </button>
          </div>
        </>
      )}
    </ModalWrapper>
  );
}

export default ModalExportClaimTasks;
